/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Tooltip, Modal, Spin, message, Typography } from 'antd';
import { SearchOutlined, TruckOutlined } from '@ant-design/icons';
import { request } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';

const { Paragraph } = Typography;

const Tcardd = () => {
  const [tdown] = Form.useForm();
  const [spinning, setSpinning] = useState(false);
  const [ticks, setticks] = useState([]);

  const [open, setOpen] = useState(false);
  const [bangm, setbangm] = useState([]);



  const toSend = async (e) => { // 数据下单
    setSpinning(true)
    setOpen(false)
    const dbd = await request.post('/ptc_do', e)

    if (dbd.return_code) { setSpinning(false) 
      setticks(dbd.ticks)
    }
    if (dbd.return_code === "F") { message.error(dbd.return_msg) } //填写邮箱,返回处理结果
    if ( dbd.return_code === "success") { message.success(dbd.return_msg) } //填写邮箱,返回处理结果

  }


  useEffect(() => {
    async function getau() {
      const res = await request.post('/ptc_list')
      setbangm(res.rescode)
    }

    getau()

  }, [ticks])


  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const ppth = (e) => {
    setOpen(true)
    tdown.setFieldsValue({ dbno: e.utno, ddno: e.key, cpname: e.pname })

  }


  const columns = [{
    title: '数据编号',
    dataIndex: 'key',
    key: 'key',
    sorter: (a, b) => a.key - b.key,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: '提货时间',
    dataIndex: 'dtime',
    key: 'dtime',
    ...getColumnSearchProps('dtime'),
  },
  {
    title: '收件人',
    dataIndex: 'shmc',
    key: 'shmc',
    ...getColumnSearchProps('shmc'),
    render: (_, record) => (<Paragraph copyable>{record.shmc}</Paragraph>),
  },
  {
    title: '联系电话',
    key: 'shphone',
    dataIndex: 'shphone',
    ...getColumnSearchProps('shphone'),
    render: (_, record) => (<Paragraph copyable>{record.shphone}</Paragraph>),
  },

  {
    title: '地址',
    dataIndex: 'address',
    key: 'address',
    ...getColumnSearchProps('address'),
    render: (_, record) => (<Paragraph copyable>{record.address}</Paragraph>),
  },
  {
    title: "",
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <Tooltip title="数据下载" ><Button type="primary" icon={<TruckOutlined />}
          // id={record.key} 
          onClick={() => ppth(record)}>发货</Button></Tooltip>
      </Space>
    ),
  },
  ];














  const [form] = Form.useForm();
  return (
    <>


      <ConfigProvider locale={zhCN} >




        <Form form={form} component={false}>

          <Table
            // rowSelection={   {type:"checkbox",...rowSelection,}} 
            columns={columns} dataSource={bangm} />

        </Form>



        <Modal
          title="发货处理"
          centered
          open={open}
          footer={false}
          onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
        >
          <Form form={tdown} onFinish={toSend}>



            <Form.Item hidden name="dbno"><Input /></Form.Item>

            <Form.Item label="数据编号" name="ddno" rules={[{ required: true, }]} >
              <Input disabled /></Form.Item>

            <Form.Item label="快递名称" name="kdmc" rules={[{ required: true, }]}  >
              <Input />


            </Form.Item>
            <Form.Item label="快递单号" name="kdbill" rules={[{ required: true, }]}   >
              <Input />

            </Form.Item>



            <Form.Item >
              <Button type="primary" htmlType="submit">
                提 交
              </Button>
            </Form.Item>

          </Form>

        </Modal>

        <Spin spinning={spinning} tip="数据整理中，请稍等..." fullscreen />

      </ConfigProvider>
    </>

  );
};
export default Tcardd;